import React, { useContext } from 'react';
import { Store } from '../../Store';
import useSearchSuggestionHandler from '../../utils/hooks/useSearchSuggestionHandler';
import SearchAutoSuggestInput from '../SearchAutoSuggestInput/SearchAutoSuggestInput';

/**
 * Search component that wraps SearchAutoSuggestInput with store data and suggestion handling
 *
 * @param {Object} props - Component props
 * @param {Array} [props.courses] - Optional list of courses to use instead of fetching from store
 * @param {string} [props.type] - Type of search (e.g., 'courses', 'contests')
 * @param {string} [props.keyValue] - Key for the input component (useful for resetting on navigation)
 * @param {string} [props.defaultValue=''] - Default search value
 * @param {string} [props.basePath='GolfCourses'] - Base path for navigation
 * @param {Object} [props.inputProps={}] - Props to pass to the input element
 * @param {string} [props.className] - CSS class for the wrapper div
 * @returns {JSX.Element} Search component
 */
const Search = ({ courses: tmpCourses, type, keyValue, defaultValue = '', inputProps = {}, className }) => {
  const { state } = useContext(Store);
  const allCourses = tmpCourses || state.allCourses?.data || [];
  const courses = state.courses?.data || [];
  const countries = state.countries?.data || [];
  const districts = state.districts?.data || [];

  const handleSuggestionSelected = useSearchSuggestionHandler({
    allCourses,
    courses,
    type
  });

  return (
    <div className={className}>
      <SearchAutoSuggestInput
        key={keyValue}
        value={defaultValue}
        golfCourses={allCourses}
        countries={countries}
        districts={districts}
        onChange={handleSuggestionSelected}
        inputProps={inputProps}
      />
    </div>
  );
};

export default Search;
